import {configStore} from 'app/store/global';

export const getPromoUrl = (): string => {
    const promoActive = configStore.CONFIG?.promo_news_active ?? 1;
    return promoActive > 0 ? '/promotions' : '/promotions_old';
};
